import {
  Component,
  ViewChild,
  ElementRef,
  OnInit,
  Inject,
  Input,
  PipeTransform,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RestService } from "../../master-services/Rest/rest.service";
import { FilexcelService } from "../../master-services/FileExcel/filexcel.service";
import { WorkService } from "../../master-services/Work/work.service";
import { UploadService } from "../../master-services/services/upload.service";
import { EstimateService } from "../../master-services/estimate/estimate.service";

/// Mis importaciones-JMV
import { OrderService } from "../../master-services/order-service/orderservice.service";
import { DecimalPipe } from "@angular/common";
import { Observable, BehaviorSubject } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { NgForm } from "@angular/forms";

/// Mis importaciones-JMV

import { ForkliftService } from "../../master-services/Forklift/forklift.service";
import { UUID } from "angular2-uuid";
import * as jsPDF from "jspdf";
import "jspdf-autotable";
import { UserOptions } from "jspdf-autotable";

import swal from "sweetalert2";
import { Router } from "@angular/router";
import { ResumenesService } from "../../master-services/resumenes/resumenes.service";
import TrmApi from "trm-api";
import { Console } from "console";
import { ModalBasicComponent } from "../../shared/modal-basic/modal-basic.component";

const trmapi = new TrmApi();
interface jsPDFWithPlugin extends jsPDF {
  autoTable: (options: UserOptions) => jsPDF;
}

interface itemSelectInterface {
  // item para mostrar selccionados
  id?: number;
  description?: string;
  type?: string;
  active?: boolean;
  part?: boolean;
  service?: boolean;
}

/// *****Variables de Prueba para Front ****

/// Comienza Paquete para produccion:
interface estimatedata {
  estimate_id?: any;
  customer_id?: any;
  customer_document?: any;
  business_name?: any;
  elaborate_user_id?: any;
  elaborate_user_name?: any;
  estimate_consecutive?: any;
  branch_office_id?: any;
  city_id?: any;
  contact?: any;
  create_at?: any;
  email?: any;
  forklift_id?: any;
  forklift_text?: any;
  guaranty?: any;
  idel?: any;
  observation?: any;
  payment_method?: any;
  settlement_status?: any;
  status?: any;
  subtotal_hours?: any;
  subtotal_parts?: any;
  telephone?: any;
  total?: any;
  update_at?: any;
  validity?: any;
  approval_comment?: any;
  approval_subtotal_parts?: any;
  approval_total?: any;
  detail_code?: any;
  detail_description?: any;
  detail_quantity?: any;
  detail_unit_cost?: any;
  detail_price?: any;
  detail_subtotal?: any;
  detail_total?: any;
  selected?: boolean;
}

let ESTIMATEDATA: estimatedata[] = [];

/// Termina Paquete para produccion

interface Country {
  id?: number;
  name: string;
  flag: string;
  area: number;
  population: number;
}
/// No borrar, de este coso depende la longfitud de la paginacion
const COUNTRIES: Country[] = [
  {
    name: "Russia",
    flag: "f/f3/Flag_of_Russia.svg",
    area: 17075200,
    population: 146989754,
  },
  {
    name: "France",
    flag: "c/c3/Flag_of_France.svg",
    area: 640679,
    population: 64979548,
  },
  {
    name: "Germany",
    flag: "b/ba/Flag_of_Germany.svg",
    area: 357114,
    population: 82114224,
  },
  {
    name: "Portugal",
    flag: "5/5c/Flag_of_Portugal.svg",
    area: 92090,
    population: 10329506,
  },
  {
    name: "Canada",
    flag: "c/cf/Flag_of_Canada.svg",
    area: 9976140,
    population: 36624199,
  },
  {
    name: "Vietnam",
    flag: "2/21/Flag_of_Vietnam.svg",
    area: 331212,
    population: 95540800,
  },
  {
    name: "Brazil",
    flag: "0/05/Flag_of_Brazil.svg",
    area: 8515767,
    population: 209288278,
  },
  {
    name: "Mexico",
    flag: "f/fc/Flag_of_Mexico.svg",
    area: 1964375,
    population: 129163276,
  },
  {
    name: "United States",
    flag: "a/a4/Flag_of_the_United_States.svg",
    area: 9629091,
    population: 324459463,
  },
  {
    name: "India",
    flag: "4/41/Flag_of_India.svg",
    area: 3287263,
    population: 1324171354,
  },
  {
    name: "Indonesia",
    flag: "9/9f/Flag_of_Indonesia.svg",
    area: 1910931,
    population: 263991379,
  },
  {
    name: "Tuvalu",
    flag: "3/38/Flag_of_Tuvalu.svg",
    area: 26,
    population: 11097,
  },
  {
    name: "China",
    flag: "f/fa/Flag_of_the_People%27s_Republic_of_China.svg",
    area: 9596960,
    population: 1409517397,
  },
];

function search(text: string, pipe: PipeTransform): Country[] {
  return COUNTRIES.filter((country) => {
    const term = text.toLowerCase();
    return (
      country.name.toLowerCase().includes(term) ||
      pipe.transform(country.area).includes(term) ||
      pipe.transform(country.population).includes(term)
    );
  });
}

function search2(text: string, pipe: PipeTransform): estimatedata[] {
  return ESTIMATEDATA.filter((estimatedata) => {
    const term = text.toLowerCase();
    return estimatedata.estimate_consecutive.toLowerCase().includes(term);
  });
}

/// *****Termina Variables de Prueba para Front ****

@Component({
  selector: "app-master-OS-customer",
  templateUrl: "./master-OS-Customer.component.html",
  styleUrls: [
    "./master-OS-customer.component.scss",
    "../../../assets/icon/icofont/css/icofont.scss",
  ],
  providers: [DecimalPipe],
})
export class MasterOSCustomerComponent implements OnInit {
  priceListMap: { [key: number]: string } = {
    0: "Seleccione origen",
    2: "USA",
    3: "ESPAÑA",
    4: "BELGICA",
    5: "SERVICIO TERCERO",
    6: "REPUESTO NACIONAL",
    7: "SIN",
    8: "USA FPE",
    9: "FLORIDA",
    10: "KANSAS",
    11: "MPE",
  };


  weightUnits = [
    { key: "1", value: "Kilogramos (kg)" }, ///Revisdar estos valores cuales son
    { key: "2", value: "Libras (lb)" },
  ];

  priceListArray: { key: number; value: string }[] = [];
  /// *** Comienza Espacio de pruebas

  countries$: Observable<Country[]>;
  filteredCountries: Country[] = [];
  filter = new FormControl("");

  collectionSize = COUNTRIES.length;
  selectedCountries: { [key: number]: boolean } = {};

  /// *** Termina Espacio de pruebas

  ////Paquete para produccion *******
  filter2 = new FormControl("");
  //selectedestimates: { [key: number]: boolean } = {};
  selectedestimates = {};
  selectedestimatesTemp: estimatedata[] = [];
  page = 1;
  pageSize = 10;

  collectionSize2: number;
  //Suscripcion de estimateData$ como observable en el servicio
  private estimateDataSubject: BehaviorSubject<any[]> = new BehaviorSubject<
    any[]
  >([]);
  public estimateData$: Observable<estimatedata[]> =
    this.estimateDataSubject.asObservable();
  public filteredEstimateData$: Observable<any[]>;
  estimateData: any; //Variable para asignar la data JSON
  estimateDataDetails: any;

  /////Aca insercion de formulario de mantenimiento
  warehouse: any;
  selectedOriginId: any = null;
  reference: string = "";
  pidUnit: number = 0;
  unitWeight: number = 0;
  productList: any[] = [];
  codeForm: any;
  quantityForm: number = 0;
  observationForm: any;
  weightType: any;
  editIndex: number | null = null; 
  warehouses:any;
  pldTotalForm:any;
  fecha_anticipo:any

  ////

  /// Construccion de variables
  showFormMaintenance = false;
  showFormCotizacion = false;
  deliveryAddress: any;
  deliveryAddressCustomer: any;

  showestimatedetails = false;
  generalObservations: string = "";
  customeremail: string = "";
  emailcartera: string = "";
  dispatchType: string = "";
  selectedFilesImages: Array<File> = [];
  selectedFiles: Array<File> = [];
  urlsImages = [];
  urlsFiles = [];
  TotalAbsolutOS: number = 0;
  ProgressOS: number = 0;
  orderservice_email_data: any;

  /// Construccion de variables
  ///Paquete para produccion *********

  myForm: FormGroup;
  myFormUpdate: FormGroup;
  submitted = false;
  submittedUpdate = false;
  rowsItems: any;
  rowsItemsWorkforce: any;
  rowsItemsparts: any;
  rowsTemp: any;
  rowStatic: any;
  rows: any;
  a: any = 5;
  iva: any = 19 / 100;
  priceIva: any = 0;
  preceIvaTol: any = 0;
  canIva: any = 0;
  kilo: any;
  elementDelete: any;
  freightGeneral;

  switchCreate = true;
  switchUpdate = true;
  change = true;
  active = false;
  inactive = false;
  enabledUpdated = false;
  selectedDepartmentId = 0;
  selectedCityId = 0;

  filterIndicatorText = false;
  filterIndicatorCheck = false;

  rowsTempCheck: any;
  rowsTempText: any;

  currentCountry: any;
  selectedEstimateCountryId: any = 0;
  estimateCountries: any;
  consecutive: any;

  currentCountryText: any;
  s3info: any;
  fileTest: any;

  forkliftText: any;

  quantity: any;
  unitCost = 0;
  weight = 0;
  weightTypeList = 0;
  priceList = 0;
  suggestedPrice: any = 0;
  price: any = 0;
  subtotal: any = 0;
  code = "";
  description = "";
  delivery: any;
  extraPercentage: any = 0;
  deliveryPart: any = 0;
  deliveryPartUpdate: any = 0;
  deliveryWorkForce: any = 0;
  deliveryWorkForceUpdate: any = 0;

  quantityUpdate = 1;
  unitCostUpdate = 0;
  weightUpdate: any = 0;
  weightTypeListUpdate = 0;
  priceListUpdate = 0;
  suggestedPriceUpdate: any = 0;
  priceUpdate: any = 0;
  subtotalUpdate: any = 0;
  codeUpdate = "";
  descriptionUpdate = "";
  deliveryUpdate: any;

  branchOffices: any = [];
  now: any;
  user: any;
  username: any;
  emailUser:any;
  user_make_os: any;
  customers: any;
  forklifts: any;
  selectedForkliftId: any = 0;
  selectedBranchOfficeId: any = 0;
  managementVariables = 0;
  managmentTariff = 0;
  finalWeight = 0;
  finalWeightUpdate = 0;
  showShippingCountriesDhlFilter: any;
  configDetailEstimates: any; // configuración de detalles
  configTrm: any;
  operationItemResult = 0;
  conditionValidation = 0;
  salePrice = 0;
  salePriceUpdate = 0;
  costTotalGlobal = 0;
  costPesosGlobal = 0;
  priceIva1: any = 0;
  preceIvaTol1: any = 0;
  fileWidth: any;

  costTotalGlobalUpdate = 0;
  costPesosGlobalUpdate = 0;

  documentCustomer: any;
  nameCustomer: any;
  cellphone: any;
  contact: any = "";
  email: any;
  days: any = 0;
  trmGeneralUsa: any;
  trmGeneralEsp: any;
  guaranty: any = 0;
  validity: any = 0;
  departments: any;
  cities: any;
  observation: any;
  selectedBusinessId: any = 0;
  descuentoOrderService: any 
  anticipoOrderService: any 
  descuentos = [
    { label: 1, value: 0.01 },
    { label: 2, value: 0.02 },
    { label: 3, value: 0.03 },
    { label: 4, value: 0.04 },
    { label: 5, value: 0.05 }
  ];
  selectedBusinessIdForm: any = 0;
  estimateId = null;
  showEstimateId = true;
  showCreateItem = false;
  showSaveFile = false;
  lowPrice: any;
  higherPrice: any;

  lowPriceUpdate: any;
  higherPriceUpdate: any;

  daysUpdate: any;

  emails;
  emailBody;
  emailSubject;

  //Varaibles de configuración validación
  suggestedMaximum: any;
  newCustomerMargin: any;
  thirdService: any;
  nationalService: any;

  conditionTrmUsa: any;
  conditionTrmEsp: any;

  blobGlobal: any;

  workforceCode: any;
  workforceService: any;
  workforcequantity: any;
  workforceHourValue: any;
  workforceSubtotal: any;
  workforceDelivery: any;

  workforceCodeUpdate: any;
  workforceServiceUpdate: any;
  workforcequantityUpdate: any;
  workforceHourValueUpdate: any;
  workforceSubtotalUpdate: any;
  workforceDeliveryUpdate: any;
  workforceDetailIdUpdate: any;

  idCustomerCreated: any;
  itemEnd = [];

  observationUpdate: any;
  validityUpdate: any;

  idDetail: any;

  rowPending: any;
  checkAllPart = false;
  itemsPart: Array<itemSelectInterface> = [];
  itemPart: itemSelectInterface;
  numberPage = 1;
  limitPage;

  separador: "."; // separador para los miles
  sepDecimal: ",";
  
  osList = [];

  @ViewChild("content") content: ElementRef;
  @ViewChild('modalEstimateOsList') modalEstimateOsList: ModalBasicComponent;

  constructor(
    private restService: RestService,
    private router: Router,
    private estimateService: EstimateService,
    private excelService: FilexcelService,
    private workService: WorkService,
    private uploadService: UploadService,
    private forkliftService: ForkliftService,
    private resumeneServices: ResumenesService,
    private orderservice: OrderService,
    public pipe: DecimalPipe
  ) {
    //*****Espacio para funciones y variables de pruebas
    this.priceListArray = Object.keys(this.priceListMap).map((key) => ({
      key: +key, // Convertir la clave a número
      value: this.priceListMap[+key],
    }));

    this.countries$ = this.filter.valueChanges.pipe(
      startWith(""),
      map((text) => search(text, pipe))
    );
    this.filteredEstimateData$ = this.estimateData$;

    //*****Espacio para funciones y variables de pruebas

    // ***Importaciones de obtencion de datos para creacion de cotizaciones

    // Get para obtener informacion de paises (En masterEstimateCustomer Component estan estas funciones)
    //this.showShippingCountriesDhlInitial();
    //this.showCountryWeight();
    //this.loadingData();
    //this.getConfigTrmInitial();
    //this.getTrmCurrent();

    // ***Importaciones de obtencion de datos para creacion de cotizaciones

    //Obtiene consecutivo Backend:"api/estimate_consecutive"

    this.getConsecutive();
    this.getWareHouse();

    // Obtiene datos de lo que es necesario para calculo de margenes comerciales

    this.getConfigEstimatesInitial();

    //Obtencion de clientes y departamentos

    if (
      Number(localStorage.getItem("profile")) == 2 ||
      Number(localStorage.getItem("profile")) == 3
    ) {
      this.getCustomerForAdvisor(Number(localStorage.getItem("userid")));
    } else {
      this.getCustomers();
    }
    this.getDepartments();

    /// Definir valores de fecha

    var date = new Date();

    // poner los 0

    var day = (date.getDate() < 10 ? "0" : "") + date.getDate();
    // 01, 02, 03, ... 10, 11, 12
    let month = (date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1);
    // 1970, 1971, ... 2015, 2016, ...
    var year = date.getFullYear();

    this.now = year + "-" + month + "-" + day;
    this.user = localStorage.getItem("username");
    this.username = localStorage.getItem("name");
    this.emailUser = localStorage.getItem("email");
    this.user_make_os = localStorage.getItem("userid");
    console.log("aca usuario id", this.user_make_os);

    /// ***Ejemplo de ejecucion Form control

    const weight = new FormControl("", Validators.required);
    const price = new FormControl("", Validators.required);

    const weightUpdate = new FormControl("", Validators.required);
    const priceUpdate = new FormControl("", Validators.required);

    this.myForm = new FormGroup({
      weight: weight,
      price: price,
    });

    this.myFormUpdate = new FormGroup({
      weightUpdate: weightUpdate,
      priceUpdate: priceUpdate,
    });
    /// ***Ejemplo de ejecucion Form control
  }

  removeAccents(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  ///#### Comienza Paquete de funciones creadas con servicios-JMV  ###

  getConsecutive2(): Promise<number> {
    return new Promise((resolve, reject) => {
      this.orderservice
        .showEstimateConsecutive()
        .then((data) => {
          const resp: any = data;
          // Calcular el nuevo consecutivo
          const date = new Date();
          const yearCosecutive = date.getFullYear().toString().substring(2, 4);
          const month =
            (date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1);
          let newConsecutive = Number(resp.data.consecutive) + 1;
          newConsecutive = Number(
            yearCosecutive + month + "0" + newConsecutive
          );

          resolve(newConsecutive);
        })
        .catch((error) => {
          console.log(error);
          reject("Error al obtener el consecutivo");
        });
    });
  }
  getConsecutive() {
    this.orderservice
      .showEstimateConsecutive()
      .then((data) => {
        const resp: any = data;
        //console.log(data);
        swal.close();
        this.consecutive = resp.data;
        var date = new Date();

        let now = date.getFullYear();

        // 01, 02, 03, ... 10, 11, 12
        let month =
          (date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1);

        let yearCosecutive = date.getFullYear().toString().substring(2, 4);
        this.consecutive = Number(this.consecutive.consecutive) + 1;
        this.consecutive = Number(
          yearCosecutive.toString() +
            month.toString() +
            "0" +
            this.consecutive.toString()
        );

        // this.rowsClient = resp.data;
        // this.rowStatic =  resp.data;
        // this.rowsTemp = resp.data;
        // //console.log( this.rowsClient);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getCustomers() {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.restService
      .getCustomer()
      .then((data) => {
        const resp: any = data;
        console.log(data);
        swal.close();
        this.customers = resp.data;

        //asignar valores customer;

        // this.rowsClient = resp.data;
        // this.rowStatic =  resp.data;
        // this.rowsTemp = resp.data;
        // //console.log( this.rowsClient);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getCustomerForAdvisor(id: any) {
    this.restService
      .getCustomersForAdvisor(id)
      .subscribe(
        data => {
          const resp: any = data;
          this.customers = resp.data;
          swal.close();
        },
        error => {
          console.log(error);
        }
      );
  }

  getEstimates2() {
    if (this.selectedBusinessId != 0) {
      this.orderservice
        .getOrderServicedata(this.selectedBusinessId.id)
        .then((data) => {
          const resp: any = data;
          //console.log("oficinas: " + data);

          this.estimateData = resp.data;
          this.collectionSize = this.estimateData.length;
          console.log(this.estimateData);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  // getEstimatesDetails3(): void {
  //   if (this.selectedBusinessId !== 0) {
  //     this.orderservice.getOrderServicedata(this.selectedBusinessId.id).subscribe(
  //       (data: any) => {
  //         if (data.success) {
  //           this.collectionSize = data.data.length;
  //           this.estimateData$ = new Observable((observer) => {
  //             observer.next(data.data);
  //             observer.complete();
  //           });
  //         } else {
  //           console.error(data.message); // Maneja el caso en el que no se encuentren resultados
  //           this.estimateData$ = new Observable((observer) => {
  //             observer.next([]); // Asigna un array vacío a estimateData$
  //             observer.complete();
  //           });
  //         }
  //       },
  //       (error) => {
  //         console.error(error); // Maneja los errores de la solicitud HTTP
  //         this.estimateData$ = new Observable((observer) => {
  //           observer.error(error); // Propaga el error al observable
  //         });
  //       }
  //     );
  //   }
  // }

  //Forma de consulta observable
  getOrderserviceData() {
    if (this.selectedBusinessId != 0) {
      swal({
        title: "Validando información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();

      this.orderservice
        .getOrderServicedata2(this.selectedBusinessId.id, true, true)
        .subscribe(
          (response) => {
            console.log("Data recibida como observable:", response);
            this.estimateDataSubject.next(response.data);
            this.collectionSize = response.data.length;
            this.customeremail = this.selectedBusinessId.email;
            swal.close();
            console.log("Acaa pasando data de direccion");
            this.getDeliverysAdrres(this.selectedBusinessId.id);

            //this.filteredEstimateData$ = this.applySearch(response.data);

            // Manejar los datos aquí
          },
          (error) => {
            console.error("Error occurred:", error);
            // Manejar el error aquí
          }
        );
    }
  }

  ///#### Termina Paquete de funciones creadas con servicios ###

  getEstimateParts() {}

  getTrmCurrent() {}

  format(inputTrm) {
    //console.log(inputTrm);
  }

  getCities() {}

  getDepartments() {}

  getForklifs() {
    if (this.selectedBranchOfficeId != 0) {
      this.forkliftService
        .getForkliftBranchOfficesFull(this.selectedBranchOfficeId.id)
        .then((data) => {
          const resp: any = data;
          //console.log("maquinas: " + data);
          swal.close();
          this.forklifts = resp.data;

          // business_name,  last_name,name, email cellphone
          // this.rowsClient = resp.data;
          // this.rowStatic =  resp.data;
          // this.rowsTemp = resp.data;
          // //console.log( this.rowsClient);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      this.selectedDepartmentId = 0;
      this.selectedCityId = 0;
      this.documentCustomer = "";
      this.nameCustomer = "";
      this.cellphone = "";
      this.contact = "";
      this.forkliftText = "";
      this.selectedForkliftId = 0;
      //  this.email =  this.selectedBusinessId.email;
      this.days = 0;
    }
  }

  getBranchOffices() {
    if (this.selectedBusinessId != 0) {
      //console.log("valor de selección");

      //console.log(this.selectedBusinessId.document_id);

      this.documentCustomer = this.selectedBusinessId.document_id;
      this.nameCustomer = this.selectedBusinessId.business_name;
      //console.log("this.selectedBusinessId.business_name");
      //console.log(this.selectedBusinessId.business_name);
      this.cellphone = this.selectedBusinessId.telephone;
      this.contact = "";
      //  this.email =  this.selectedBusinessId.email;
      this.days = this.selectedBusinessId.day;
      this.selectedDepartmentId = this.selectedBusinessId.department_id;

      this.getCities();
      //console.log("this.selectedBusinessId.id");
      //console.log(this.selectedBusinessId.id);

      this.restService
        .getOffice(this.selectedBusinessId.id)
        .then((data) => {
          const resp: any = data;
          //console.log("oficinas: " + data);
          swal.close();
          this.branchOffices = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      this.selectedDepartmentId = 0;
      this.selectedCityId = 0;
      this.documentCustomer = "";
      this.nameCustomer = "";
      this.cellphone = "";
      this.contact = "";
      //  this.email =  this.selectedBusinessId.email;
      this.days = 0;
    }
  }

  loadingData() {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.estimateService
      .getEstimateCountries()
      .then((data) => {
        const resp: any = data;
        this.estimateCountries = resp.data;
        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  createEstimateDetail() {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    // //console.log(this.lowPrice+ '--' +this.price+ '--'+ this.higherPrice);

    // let priceTemp = this.price.toString().replace('.','').replace(',','.');

    // let priceTempStr = this.price.toString();
    // priceTempStr = priceTempStr.split('.').join('');
    let priceTemp = this.changeFormatDecimal(this.price); //

    //console.log("OLEOLE IMPORT");
    //console.log(this.price);
    //console.log(this.price.toString().replace(".", ""));
    //console.log("arreglate porfavor");
    //console.log(
    //   "--->" + priceTemp + "---" + this.lowPrice + "--" + this.higherPrice
    // );
    //console.log(
    //   "-----" +
    //     Number(priceTemp) +
    //     "--->=----" +
    //     Number(this.lowPrice) +
    //     "----&&----" +
    //     Number(priceTemp) +
    //     "---<=---" +
    //     Number(this.higherPrice)
    // );
    if (
      Number(priceTemp) >= Number(this.lowPrice) &&
      Number(priceTemp) <= Number(this.higherPrice)
    ) {
      let estimateIdDetailTemp = this.estimateId;
      let codeTemp = this.code;
      let descriptionTemp = this.description;
      let quantityTemp = this.quantity;
      let unitCostTemp = this.unitCost;
      let priceListTemp = this.priceList;
      let iva = this.priceIva1;
      let priceSuggestTemp = this.changeFormatDecimal(this.suggestedPrice); // this.suggestedPrice;
      let daysTemp = this.days;
      let preceIvaTo = this.preceIvaTol1;
      // priceTemp ya se asigno
      // let priceTemp = this.price;
      let deliveryPartTemp = this.deliveryPart;
      let weightTemp = this.weight;
      let totalTemp = this.changeFormatDecimal(this.subtotal); //this.subtotal.toString().replace('.','').replace(',','.');
      let observationTemp = this.observation;
      let statusTemp = 0;
      //console.log("Antes de guardar");
      //console.log(this.subtotal);
      let subtotalTemp = this.changeFormatDecimal(this.subtotal);
      let typeServiceTemp = 0;
      let weightTypeList = this.weightTypeList;
      //console.log("estos son los puntos");

      this.estimateService
        .createEstimateDetails(
          estimateIdDetailTemp,
          codeTemp,
          descriptionTemp,
          quantityTemp,
          unitCostTemp,
          priceListTemp,
          priceSuggestTemp,
          weightTemp,
          priceTemp,
          subtotalTemp,
          iva,
          deliveryPartTemp,
          totalTemp,
          preceIvaTo,
          statusTemp,
          typeServiceTemp,
          weightTypeList
        )
        .then((data) => {
          const resp: any = data;
          swal({
            title: "Item creado",
            type: "success",
          });
          document.getElementById("createItemHide").click();
          this.clearFormDetail();
          // this.getEstimateDetails();

          this.getEstimateParts();

          //console.log(resp);
        })
        .catch((error) => {
          swal({
            title: "Se presento un problema, para guardar este item",
            type: "error",
          });

          console.log(error);
        });
    } else {
      swal({
        title:
          "Se presentó un problema ----" +
          priceTemp +
          "---" +
          this.lowPrice +
          "--" +
          this.higherPrice,
        text: "El precio asignado está por debajo del sugerido o está por encima del porcentaje permitido",
        type: "error",
      });
    }
  }

  changeFormatDecimal(price: any) {
    let priceTempStr = price.toString();
    priceTempStr = priceTempStr.split(".").join("");
    let priceTemp = priceTempStr.replace(",", ".");
    return priceTemp;
  }

  updateEstimateDetail() {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    // //console.log(this.lowPrice+ '--' +this.price+ '--'+ this.higherPrice);
    let priceUpdateTemp = this.changeFormatDecimal(this.priceUpdate); //
    this.lowPriceUpdate = this.changeFormatDecimal(this.suggestedPriceUpdate);
    this.higherPriceUpdate = Number(
      this.lowPriceUpdate * (1 + this.suggestedMaximum / 100)
    ).toFixed(0);
    //console.log("info de importante");
    //console.log(
    //   "----" +
    //     priceUpdateTemp +
    //     "----" +
    //     this.lowPriceUpdate +
    //     "---" +
    //     this.higherPriceUpdate +
    //     "---" +
    //     this.suggestedMaximum
    // );
    // cambio YCV

    if (
      Number(priceUpdateTemp) >= Number(this.lowPriceUpdate) &&
      Number(priceUpdateTemp) <= Number(this.higherPriceUpdate)
    ) {
      let estimateIdDetailTemp = this.idDetail;
      let codeTemp = this.codeUpdate;
      let descriptionTemp = this.descriptionUpdate;
      let quantityTemp = this.quantityUpdate;
      let unitCostTemp = this.unitCostUpdate;
      let priceListTemp = this.priceListUpdate;
      let priceSuggestTemp = this.changeFormatDecimal(
        this.suggestedPriceUpdate
      );
      let daysTemp = this.daysUpdate;
      // let priceTemp = this.priceUpdate;
      let deliveryPartTemp = this.deliveryPartUpdate;
      let weightTemp = this.weightUpdate;
      let totalTemp = this.changeFormatDecimal(this.subtotalUpdate);
      let observationTemp = this.observationUpdate;
      let statusTemp = 0;
      //console.log("Antes de guardar");
      //console.log(this.subtotalUpdate);
      let subtotalTemp = this.changeFormatDecimal(this.subtotalUpdate);
      let typeServiceTemp = 0;
      let weightTypeTemp = this.weightTypeListUpdate;
      let iva = this.priceIva;
      let preceIvaTol = this.preceIvaTol;
      this.estimateService
        .updateEstimateDetails(
          estimateIdDetailTemp,
          codeTemp,
          descriptionTemp,
          quantityTemp,
          unitCostTemp,
          priceListTemp,
          priceSuggestTemp,
          weightTemp,
          priceUpdateTemp,
          subtotalTemp,
          iva,
          deliveryPartTemp,
          totalTemp,
          preceIvaTol,
          statusTemp,
          typeServiceTemp,
          weightTypeTemp
        )
        .then((data) => {
          const resp: any = data;
          swal({
            title: "Item actualizado",
            type: "success",
          });

          document.getElementById("updateItemHide").click();
          this.clearFormDetailUpdate();
          // this.getEstimateDetails();

          this.getEstimateParts();

          //console.log(resp);
        })
        .catch((error) => {
          swal({
            title: "Se presento un problema, para guardar este item",
            type: "error",
          });

          console.log(error);
        });
    } else {
      swal({
        title: "Se presentó un problema",
        text: "El precio asignado está por debajo del sugerido o está por encima del porcentaje permitido",
        type: "error",
      });
    }
  }

  //

  updateEstimateDetailWorkforce() {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    // //console.log(this.lowPrice+ '--' +this.price+ '--'+ this.higherPrice);
    let estimateIdDetailTemp = this.workforceDetailIdUpdate;
    let codeTemp = this.workforceCodeUpdate;
    let serviceTemp = this.workforceServiceUpdate;
    let quantityTemp = this.workforcequantityUpdate;
    let hourValueTemp = this.changeFormatDecimal(this.workforceHourValueUpdate);
    let subtotalTemp = this.changeFormatDecimal(this.workforceSubtotalUpdate);
    let deliveryTemp = this.workforceDeliveryUpdate;
    let statusTemp = 0;
    let typeServiceTemp = 1;

    this.estimateService
      .updateEstimateDetailWorkforce(
        estimateIdDetailTemp,
        codeTemp,
        serviceTemp,
        quantityTemp,
        hourValueTemp,
        subtotalTemp,
        deliveryTemp,
        subtotalTemp,
        statusTemp,
        typeServiceTemp
      )
      .then((data) => {
        const resp: any = data;
        swal({
          title: "Item actualizado",
          type: "success",
        });

        document.getElementById("updateItemHideDetailWorkforce").click();

        this.clearFormDetailWorkUpdate();
        // this.getEstimateDetails();

        this.getEstimateParts();

        //console.log(resp);
      })
      .catch((error) => {
        swal({
          title: "Se presento un problema, para guardar este item",
          type: "error",
        });

        console.log(error);
      });
  }

  sendPriceCountries() {
    //console.log(localStorage.getItem("token"));
    this.submitted = true;
    if (!this.myForm.invalid) {
      swal({
        title: "Validando información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();

      this.estimateService
        .createPriceCountries(
          Number(this.selectedEstimateCountryId.id),
          this.myForm.get("weight").value.toUpperCase(),
          this.myForm.get("price").value.toUpperCase()
        )
        .then((data) => {
          const resp: any = data;
          //console.log(resp);
          if (resp.success === false) {
            swal({
              title: "Este peso ya esta registrado",
              text: "Este peso no se puede registrar",
              type: "error",
            });
          } else {
            this.myForm.get("weight").setValue("");
            this.myForm.get("price").setValue("");
            /*swal({
             title: 'Marca agregada',
             type: 'success'
            });*/
            //   this.router.navigateByUrl('master/registerBrand');

            document.getElementById("createCountryHide").click();
            this.ChangingValue();
            swal({
              title: "País agregado",
              type: "success",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  ChangingValue() {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    //console.log("--------------");
    this.currentCountryText = this.selectedEstimateCountryId.name;
    //console.log("-----*******---------");
    //console.log(this.currentCountryText);
    //console.log(this.selectedEstimateCountryId.id);
    this.estimateService
      .getPriceDhlCountry(Number(this.selectedEstimateCountryId.id))
      .then((data) => {
        const resp: any = data;
        //console.log(data);
        //this.rowsClient = resp.data;
        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  sendUpdatePriceCountries() {
    this.submittedUpdate = true;
    if (!this.myFormUpdate.invalid) {
      swal({
        title: "Validando información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();
      //console.log("-----------------");
      // //console.log(
      //   Number(this.currentCountry.id) +
      //     "-" +
      //     Number(this.myFormUpdate.get("weightUpdate").value) +
      //     "-" +
      //     Number(this.myFormUpdate.get("priceUpdate").value)
      // );
      //console.log("----------------------");
      this.estimateService
        .updatePriceCountries(
          Number(this.currentCountry.id),
          Number(this.myFormUpdate.get("weightUpdate").value),
          Number(this.myFormUpdate.get("priceUpdate").value)
        )
        .then((data) => {
          const resp: any = data;
          //console.log(resp);
          if (resp.error) {
            swal({
              title: "Esta país ya esta registrado",
              text: "Este país no se puede actualizar",
              type: "error",
            });
          } else {
            // this.router.navigateByUrl('master/registerBrand');
            document.getElementById("updateCountryHide").click();
            this.ChangingValue();
            swal({
              title: "Marca actualizada",
              type: "success",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  get checkForm() {
    return this.myForm.controls;
  }
  get checkFormUpdate() {
    return this.myFormUpdate.controls;
  }

  updateItems(item: any) {
    //console.log("-----------------------");
    //console.log(item);
    this.idDetail = item.id;
    this.codeUpdate = item.code;
    this.descriptionUpdate = item.description;
    this.quantityUpdate = item.quantity;
    this.unitCostUpdate = item.unit_cost;
    this.priceListUpdate = item.price_list;
    this.priceListUpdate = item.price_list;
    this.priceIva = item.iva;
    this.preceIvaTol = item.total_iva;

    this.suggestedPriceUpdate = this.finalFormatStandard(
      Number(item.price_suggest).toFixed(0)
    );
    this.priceUpdate = this.finalFormatStandard(Number(item.price).toFixed(0));
    this.subtotalUpdate = this.finalFormatStandard(
      Number(item.subtotal).toFixed(0)
    );
    this.deliveryUpdate = item.delivery;
    this.weightUpdate = item.weight;
    this.weightTypeListUpdate = item.weight_type;
    this.deliveryPartUpdate = item.delivery;
    //console.log(item);
    document.getElementById("uploadItem").click();
  }

  updateWorkForceItems(item: any) {
    this.workforceDetailIdUpdate = item.id;
    this.workforceCodeUpdate = item.code;
    this.workforceServiceUpdate = item.service;
    this.workforcequantityUpdate = item.quantity;
    this.workforceHourValueUpdate = this.finalFormatStandard(
      Number(item.hour_value).toFixed(0)
    );
    this.workforceSubtotalUpdate = Number(item.subtotal).toFixed(0);
    this.workforceDeliveryUpdate = item.delivery;

    //console.log(item);
    document.getElementById("uploadWorkforceItem").click();
  }

  deletePriceCountry(item: any) {
    swal({
      title: "Estás seguro de eliminar este elemento?",
      // text: 'Once deleted, you will not be able to recover this imaginary file!',
      type: "warning",
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: "No",
      confirmButtonText: "Si",
    }).then((willDelete) => {
      if (willDelete.value) {
        this.elementDelete = item;
        //console.log(item);
        //console.log(this.elementDelete);
        swal.showLoading();
        this.estimateService
          .deletePriceCountries(Number(this.elementDelete.id))
          .then((data) => {
            swal.showLoading();
            const resp: any = data;
            //console.log(resp);

            if (resp.success === false) {
              swal({
                title: "Este peso presenta problemas",
                text: "Este peso no se puede eliminar",
                type: "error",
              });
            } else {
              // this.router.navigateByUrl('master/registerBrand');
              this.ChangingValue();
              swal({
                title: "Peso eliminada",
                type: "success",
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
        //console.log(this.elementDelete.id);
      } else {
        // swal('Fail');
      }
      //console.log(willDelete);
    });
  }

  deleteEstimateDetail(item: any) {
    swal({
      title: "Estás seguro de eliminar este elemento?",
      // text: 'Once deleted, you will not be able to recover this imaginary file!',
      type: "warning",
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: "No",
      confirmButtonText: "Si",
    }).then((willDelete) => {
      if (willDelete.value) {
        this.elementDelete = item;
        //console.log(item);
        //console.log(this.elementDelete);
        swal.showLoading();
        this.estimateService
          .deleteEstimateDetail(Number(this.elementDelete.id))
          .then((data) => {
            swal.showLoading();
            const resp: any = data;
            //console.log(resp);

            if (resp.success === false) {
              swal({
                title: "Este peso presenta problemas",
                text: "Este peso no se puede eliminar",
                type: "error",
              });
            } else {
              // this.router.navigateByUrl('master/registerBrand');
              this.ChangingValue();
              swal({
                title: "Elemento eliminado",
                type: "success",
              });

              this.getEstimateParts();
            }
          })
          .catch((error) => {
            console.log(error);
          });
        //console.log(this.elementDelete.id);
      } else {
        // swal('Fail');
      }
      //console.log(willDelete);
    });
  }

  calculateFreight(weight: number, price: number) {
    if (this.weightTypeList == 1) {
      weight = weight / 2.2;
    }

    weight = weight * 1.1;
    let result = 0;
    //console.log("Este es el peso final" + weight);

    if (weight > 1) {
      let vInput = weight;
      let b = Math.trunc(vInput);

      //console.log("este es el valor de " + b);
      let c = vInput % b;

      //console.log("este es el valor de c" + c);
      if (c > 0) {
        if (c > 0.5) {
          result = b + 1;
        } else {
          result = b + 0.5;
        }
      } else {
        result = b;
      }
      //console.log("REDONDEO DE VALORES A " + result);
    } else {
      //console.log("Ingreso Hpta");
      if (weight <= 0.5) {
        result = 0.5;
        //console.log("Ingreso ---------------");
      } else {
        result = 1;
        //console.log("Ingreso ---------------ala 1");
      }
    }

    //console.log("-------------------------- este es el titulo");
    //console.log("peso: " + result + " precio: " + price + "peso" + weight);

    if (price < 1000 && weight < 45) {
      this.conditionValidation = 1;
    } else if (price >= 1000 && price <= 1999 && weight < 45) {
      this.conditionValidation = 2;
      //console.log("REDONDEO DE VALORES " + result);
      weight = result;
    } else if (price >= 2000 || weight >= 45) {
      this.conditionValidation = 3;
    }

    //console.log("condición final: " + this.conditionValidation);
    this.finalWeight = weight;
    //console.log(
    //   "condicion " +
    //     this.conditionValidation +
    //     " preciosLista " +
    //     this.priceList +
    //     " peso " +
    //     weight
    // );

    this.showShippingCountriesDhl(
      this.conditionValidation,
      this.priceList,
      weight,
      0
    ); // create
    //console.log("Importante informacion: " + this.conditionValidation);
  }

  calculateFreightUpdate(weight: number, price: number) {
    if (this.weightTypeListUpdate == 1) {
      weight = weight / 2.2;
    }

    weight = weight * 1.1;
    let result = 0;
    //console.log("Este es el peso final" + weight);

    if (weight > 1) {
      let vInput = weight;
      let b = Math.trunc(vInput);

      //console.log("este es el valor de " + b);
      let c = vInput % b;

      //console.log("este es el valor de c" + c);
      if (c > 0) {
        if (c > 0.5) {
          result = b + 1;
        } else {
          result = b + 0.5;
        }
      } else {
        result = b;
      }
      //console.log("REDONDEO DE VALORES A " + result);
    } else {
      //console.log("Ingreso Hpta");
      if (weight <= 0.5) {
        result = 0.5;
        //console.log("Ingreso ---------------");
      } else {
        result = 1;
        //console.log("Ingreso ---------------ala 1");
      }
    }

    //console.log("-------------------------- este es el titulo");
    //console.log("peso: " + result + " precio: " + price + "pesok" + weight);

    if (price < 1000 && weight < 45) {
      this.conditionValidation = 1;
    } else if (price >= 1000 && price <= 1999 && weight < 45) {
      this.conditionValidation = 2;
      //console.log("REDONDEO DE VALORES " + result);
      weight = result;
    } else if (price >= 2000 || weight >= 45) {
      this.conditionValidation = 3;
    }

    //console.log("condición final: " + this.conditionValidation);
    this.finalWeightUpdate = weight;
    this.showShippingCountriesDhl(
      this.conditionValidation,
      this.priceListUpdate,
      weight,
      1
    ); // update
    //console.log("Importante informacion: " + this.conditionValidation);
  }

  ngOnInit() {}

  blockAgents(vadr: any) {
    //console.log(vadr);
  }

  showShippingCountriesDhlInitial() {}

  getConfigTrmInitial() {
    this.estimateService
      .getConfigTrm()
      .then((data) => {
        const resp: any = data;
        //console.log("Este es la API DE CONFIGURACIÓN-------");
        //console.log(data);

        //console.log("TRM CURRENT " + JSON.stringify(resp));

        this.conditionTrmUsa = resp.data[0]; // Configuración de TRM USA
        this.conditionTrmEsp = resp.data[1]; // Configuración de TRM ESP

        if (this.conditionTrmUsa.id == 2) {
          if (this.conditionTrmUsa.id == 2) {
            this.trmGeneralUsa = Number(this.conditionTrmUsa.constant).toFixed(
              2
            );
            //console.log("este es la TRMUSA " + this.trmGeneralUsa);

            this.trmGeneralEsp = (
              this.trmGeneralUsa * this.conditionTrmEsp.constant
            ).toFixed(2);
            //console.log("este es la TRMESPAÑA " + this.trmGeneralUsa);
          }
        } else {
          let trm;
          trmapi
            .latest()
            .then((data) => {
              //console.log(data);
              trm = data.valor;
              if (this.conditionTrmUsa.id == 1) {
                this.trmGeneralUsa = trm;
              }

              if (this.conditionTrmUsa.id == 3) {
                //console.log(trm);
                //console.log(this.conditionTrmUsa.constant);
                this.trmGeneralUsa =
                  trm + Math.trunc(this.conditionTrmUsa.constant);
              }

              this.trmGeneralEsp = (
                this.trmGeneralUsa * this.conditionTrmEsp.constant
              ).toFixed(2);
              //console.log("este es la TRMESPAÑA " + this.trmGeneralUsa);

              //console.log("para ver el id");
              //console.log(this.conditionTrmUsa);
            })
            .catch((error) => {
              console.log(error);
              this.estimateService
                .showTrmCurrent()
                .then((data) => {
                  const resp: any = data;
                  //let trm = resp.data.value;
                  //console.log("RESP " + JSON.stringify(resp));

                  try {
                    trm = resp.data.value;
                  } catch (error) {
                    trm = resp.result.value;
                  }

                  //console.log("TRM CURRENT 123" + JSON.stringify(resp));

                  if (this.conditionTrmUsa.id == 1) {
                    this.trmGeneralUsa = trm;
                  }

                  if (this.conditionTrmUsa.id == 3) {
                    //console.log(trm);
                    //console.log(this.conditionTrmUsa.constant);
                    this.trmGeneralUsa =
                      trm + Math.trunc(this.conditionTrmUsa.constant);
                  }

                  this.trmGeneralEsp = (
                    this.trmGeneralUsa * this.conditionTrmEsp.constant
                  ).toFixed(2);
                  //console.log("este es la TRMESPAÑA " + this.trmGeneralUsa);

                  //console.log("para ver el id");
                  //console.log(this.conditionTrmUsa);

                  //  trm = trm.toString().replace('.',',');
                  //   let trmSecondPart =trm.substring(1);
                  //  let trmFirtsPart = trm.substring(0, 1);
                  //  this.trmGeneral= trmFirtsPart+'.'+trmSecondPart;
                  //  swal.close();

                  //console.log(this.cities);
                })
                .catch((error) => {
                  console.log(error);
                });
            });
        }
        this.configTrm = resp.data;
        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getForkliftText() {
    //console.log(this.selectedForkliftId.full_name);
    //console.log(this.selectedForkliftId);
    this.forkliftText = this.selectedForkliftId.full_name;
  }

  updatePendingCheck() {
    //console.log(this.itemsPart);
    var cont = 0;
    for (let item of this.itemsPart) {
      if (item.active) {
        cont++;
        if (item.type == "CHECKLIST") {
          this.updateStatusChecklistPending(item.id, 1);
        }
        if (item.type == "CORRECTIVO") {
          this.updateStatusCorrectivePending(item.id, 1);
        }
        if (item.type == "PREVENTIVO") {
          this.updateStatusPreventivePending(item.id, 1);
        }
        if (item.type == "PLATAFORMA") {
          this.updateStatusPlatformPending(item.id, 1);
        }
        if (item.type == "ESTIBADORES") {
          this.updateStatusStevedorePending(item.id, 1);
        }
        if (item.type == "BATERIA") {
          this.updateStatusBatteryPending(item.id, 1);
        }
      }
    }
    //console.log(cont);
    if (cont >= 1) {
      document.getElementById("storageDetaiPendinglHide").click();
    } else {
      swal({
        title: "Seleccionar al menos un pediente,",
        type: "error",
      });
    }
  }

  validateCheck(row: any, ind: number) {
    //console.log(row);
    if (ind == 1 && row.service == true) {
      for (let item of this.itemsPart) {
        if (row.id == item.id && row.type == item.type) {
          item.service = false;
        }
      }
    }
    if (ind == 2 && row.part == true) {
      for (let item of this.itemsPart) {
        if (row.id == item.id && row.type == item.type) {
          item.part = false;
        }
      }
    }
  }

  getPendingForklift() {
    this.resumeneServices
      .getForkliftPendingGeneral(this.selectedForkliftId.id)
      .then((data) => {
        const resp: any = data;
        // //console.log(
        //   "Este es la API DE CONFIGURACIÓN TOPE MAXIMO, MARGEN, ST,SN"
        // );
        //console.log(data);
        this.rowPending = resp.data;
        this.itemsPart.length = 0;
        //console.log(this.itemsPart);
        for (let item of this.rowPending) {
          this.itemPart = {
            id: item.id,
            description: item.description,
            type: item.type,
            active: false,
          };
          this.itemsPart.push(this.itemPart);
        }

        document.getElementById("checkPendingForklift").click();

        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  checkUncheckAllPart(event: any) {
    this.checkAllPart = event.target.checked;
    for (let i = 0; i < this.itemsPart.length; i++) {
      //console.log("lo encontre" + i);
      this.itemsPart[i].active = event.target.checked;
    }
  }

  partChangeActive(event: any, item: any) {
    //console.log("valor para editar");
    //console.log(event);
    //console.log(item);
    //console.log(item.id);

    for (let i = 0; i < this.itemsPart.length; i++) {
      if (this.itemsPart[i].id == item.id) {
        //console.log(item);
        //console.log("lo encontre" + i);
        this.itemsPart[i].active = event.target.checked;
        //console.log(this.itemsPart[i]);
      }
    }
  }

  nextPage() {
    this.numberPage = this.numberPage + 1;
    // this.showSettlementEstimateCustomer();
  }
  backPage() {
    if (this.numberPage > 1) {
      this.numberPage = this.numberPage - 1;
      // this.showSettlementEstimateCustomer();
    }
  }

  deleteItemsSelect() {
    this.itemsPart = [];
    document.getElementById("storageDetailPendinglHide").click();
  }

  updateStatusPreventivePending(id: number, status: number) {
    this.resumeneServices
      .updateStatusPendingPreventive(
        id,
        status,
        this.consecutive,
        this.estimateId
      )
      .then((data) => {
        const resp: any = data;
        // //console.log('Este es la API DE pendientes');
        //console.log(data);

        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }
  updateStatusCorrectivePending(id: number, status: number) {
    this.resumeneServices
      .updateStatusPendingCorrective(
        id,
        status,
        this.consecutive,
        this.estimateId
      )
      .then((data) => {
        const resp: any = data;
        // //console.log('Este es la API DE pendientes');
        //console.log(data);

        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }
  updateStatusChecklistPending(id: number, status: number) {
    this.resumeneServices
      .updateStatusPendingChecklist(
        id,
        status,
        this.consecutive,
        this.estimateId
      )
      .then((data) => {
        const resp: any = data;
        // //console.log('Este es la API DE pendientes');
        //console.log(data);

        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }
  updateStatusStevedorePending(id: number, status: number) {
    this.resumeneServices
      .updateStatusPendingStevedore(
        id,
        status,
        this.consecutive,
        this.estimateId
      )
      .then((data) => {
        const resp: any = data;
        // //console.log('Este es la API DE pendientes');
        //console.log(data);

        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }
  updateStatusPlatformPending(id: number, status: number) {
    this.resumeneServices
      .updateStatusPendingPlatform(
        id,
        status,
        this.consecutive,
        this.estimateId
      )
      .then((data) => {
        const resp: any = data;
        // //console.log('Este es la API DE pendientes');
        //console.log(data);

        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }
  updateStatusBatteryPending(id: number, status: number) {
    this.resumeneServices
      .updateStatusPendingBattery(id, status, this.consecutive, this.estimateId)
      .then((data) => {
        const resp: any = data;
        // //console.log('Este es la API DE pendientes');
        //console.log(data);

        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  createEstimateDetailWorkforcePending(item: any, status: number) {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    //console.log("entro al de crear por pendiente");
    let estimateIdTemp = this.estimateId;

    let serviceTemp = this.workforceService;

    let typeService = 1;
    let statusTemp = 0;

    this.estimateService
      .createEstimateDetailWorkforceForPending(
        estimateIdTemp,
        serviceTemp,
        statusTemp,
        typeService
      )
      .then((data) => {
        const resp: any = data;
        swal({
          title: "Item creado",
          type: "success",
        });
        if (item.type == "CHECKLIST") {
          this.updateStatusChecklistPending(item.id, status);
        }
        if (item.type == "CORRECTIVO") {
          this.updateStatusCorrectivePending(item.id, status);
        }
        if (item.type == "PREVENTIVO") {
          this.updateStatusPreventivePending(item.id, status);
        }
        if (item.type == "PLATAFORMA") {
          this.updateStatusPlatformPending(item.id, status);
        }
        if (item.type == "ESTIBADORES") {
          this.updateStatusStevedorePending(item.id, status);
        }
        if (item.type == "BATERIA") {
          this.updateStatusBatteryPending(item.id, status);
        }

        /* this.workforceCode = '';
        this.workforceService = '';
        this.workforcequantity = 1;
         this.workforceHourValue = 0;
        this.workforceSubtotal = 0;
        this.workforceDelivery = 0;*/

        //  document.getElementById('createItemHideDetailWorkforce').click();
        //  this.clearFormDetailWork();
        // this.getEstimateDetails();
        this.getEstimateParts();

        //console.log(resp);
      })
      .catch((error) => {
        swal({
          title: "Se presento un problema, para guardar este item",
          type: "error",
        });

        console.log(error);
      });
  }

  createEstimateDetailForPending(item: any, status) {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    //console.log("Crear por pendiente");
    // //console.log(this.lowPrice+ '--' +this.price+ '--'+ this.higherPrice);

    let estimateIdDetailTemp = this.estimateId;
    let descriptionTemp = this.description;
    let statusTemp = 0;
    // let subtotalTemp = this.changeFormatDecimal(this.subtotal);
    let typeServiceTemp = 0;

    this.estimateService
      .createEstimateDetailsPending(
        estimateIdDetailTemp,
        descriptionTemp,
        statusTemp,
        typeServiceTemp
      )
      .then((data) => {
        const resp: any = data;
        swal({
          title: "Item creado",
          type: "success",
        });
        //  document.getElementById( 'createItemHide').click();
        //  this.clearFormDetail();
        // this.getEstimateDetails();
        if (item.type == "CHECKLIST") {
          this.updateStatusChecklistPending(item.id, status);
        }
        if (item.type == "CORRECTIVO") {
          this.updateStatusCorrectivePending(item.id, status);
        }
        if (item.type == "PREVENTIVO") {
          this.updateStatusPreventivePending(item.id, status);
        }
        if (item.type == "PLATAFORMA") {
          this.updateStatusPlatformPending(item.id, status);
        }
        if (item.type == "BATERIA") {
          this.updateStatusBatteryPending(item.id, status);
        }
        if (item.type == "ESTIBADORES") {
          this.updateStatusStevedorePending(item.id, status);
        }

        this.getEstimateParts();

        //console.log(resp);
      })
      .catch((error) => {
        console.log(error);
        swal({
          title: "Se presento un problema, para guardar este item",
          type: "error",
        });

        console.log(error);
      });
  }

  getConfigEstimatesInitial() {
    this.estimateService
      .getConfigEstimates()
      .then((data) => {
        const resp: any = data;
        //console.log(
        //   "Este es la API DE CONFIGURACIÓN TOPE MAXIMO, MARGEN, ST,SN"
        // );
        //console.log(data);
        this.configDetailEstimates = resp.data;

        this.suggestedMaximum = this.configDetailEstimates[0].constant;
        this.newCustomerMargin = this.configDetailEstimates[1].constant;
        this.thirdService = this.configDetailEstimates[2].constant;
        //console.log(this.thirdService);
        this.nationalService = this.configDetailEstimates[3].constant;

        //console.log("Servicio nacional");
        //console.log(this.nationalService);

        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  showShippingCountriesDhl(
    conditionValidation: number,
    country: number,
    weight: number,
    ind: number
  ) {}

  showCountryWeight(country: number, weight: number, ind: number) {}

  calculateFreightValues() {}

  calculateFreightValuesUpdate() {}

  finalOperation(country: number) {}

  calcularIva() {
    let priceIva = this.price * this.iva;
    this.priceIva1 = this.finalFormat(Number(priceIva).toFixed(0));
    this.preceIvaTol1 = this.finalFormat(
      Number(this.subtotal + priceIva).toFixed(0)
    );
  }

  finalOperationUpdate(country: number) {}

  calcularIvaUpdate() {
    let priceIvaUdate = this.priceUpdate * this.iva;
    this.priceIva = Number(priceIvaUdate).toFixed(0);
    this.preceIvaTol = Number(this.subtotalUpdate + priceIvaUdate).toFixed(0);
  }

  public downloadPdf() {}

  uploadImagesEstimate() {
    for (let file of this.selectedFilesImages) {
      const fileole = file[0];
      //console.log(fileole);
      const uuid = UUID.UUID();
      //console.log(uuid);
      //console.log(fileole.name + "" + fileole.type);
      const extension = fileole.name
        .substring(fileole.name.lastIndexOf("."))
        .toLowerCase();
      //console.log(extension);
      this.uploadService
        .uploadFileEstimate(fileole)
        .then((res) => {
          //console.log("s3info" + JSON.stringify(res));
          this.s3info = res;
          //console.log(this.s3info);
          //this.insertNew();
        })
        .catch((error) => {
          console.log(error);
          swal({
            type: "error",
            title: "Oops a currido un error",
            text: "Se ha presentado un error al subir la imagen",
            allowOutsideClick: false,
          });
        });
    }
  }

  normalizes = (function () {
    var from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç$#+*%&!¡¿?|¬",
      to = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc",
      mapping = {};

    for (var i = 0, j = from.length; i < j; i++)
      mapping[from.charAt(i)] = to.charAt(i);

    return function (str) {
      var ret = [];
      for (var i = 0, j = str.length; i < j; i++) {
        var c = str.charAt(i);
        if (mapping.hasOwnProperty(str.charAt(i))) ret.push(mapping[c]);
        else ret.push(c);
      }
      return ret.join("");
    };
  })();

  uploadFilesImages() {
    //console.log("esta es la longitud: " + this.selectedFilesImages.length);
    //console.log("contenido" + this.selectedFilesImages);
    for (let fileCurrent of this.selectedFilesImages) {
      const file = fileCurrent[0];
      var img = new Image();
      img = file;

      img.width = 30;
      img.height = 300;
      //console.log("info de file");
      //console.log(file);
      const uuid = UUID.UUID();
      //console.log(uuid);
      //console.log(img.name + "" + file.type);
      const extension = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();
      //console.log(extension);
      // 1 son las imagenes
      let nameTemp = this.removeAccents(
        this.consecutive + this.normalizes(file.name.replace(/\s/g, ""))
      );
      // let nameTemp= this.consecutive +file.name.replace(/\s/g,"");
      this.uploadService
        .uploadFilesAll(img, this.estimateId, 1, nameTemp)
        .then((res) => {
          //console.log("s3info" + JSON.stringify(res));
          this.s3info = res;
          //console.log(this.s3info);
          /*swal({
          title: 'Imagenes guardadas',
          type: 'success'
         });*/

          swal.close();

          //this.insertNew();
        })
        .catch((error) => {
          console.log(error);
          swal({
            type: "error",
            title: "Oops a currido un error",
            text: "Se ha presentado un error al subir la imagen",
            allowOutsideClick: false,
          });
        });
    }
  }

  deleteImage(i: number) {
    if (this.showSaveFile == true) {
      //console.log("Este es el valor de i " + i);
      //console.log(i);
      this.urlsImages.splice(i, 1);
      this.selectedFilesImages.splice(i, 1);
    } else {
      swal({
        title:
          "No se permite eliminar la imagen, debes ir a editar la cotización",
        type: "error",
      });
    }
  }

  deleteFile(i: number) {
    if (this.showSaveFile == true) {
      //console.log("Este es el valor de i ");
      //console.log(i);
      this.urlsFiles.splice(i, 1);
      this.selectedFiles.splice(i, 1);
    } else {
      swal({
        title:
          "No se permite eliminar el archivo, debes ir a editar la cotización",
        type: "error",
      });
    }
  }

  dataURItoBlob(dataURI) {}

  downloadEcxel(): void {}

  convertImgToBase64() {}

  getBase64Image() {}

  download() {}

  upload() {}

  upload3() {}

  createEstimateCondition() {}

  /* validateEmail( email )
 {
     var regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
     return regex.test(email) ? true : false;
 }*/

  createEstimate() {}

  createEstimateDetailWorkforce() {}

  ///////////Paquete #1 ****** Paquete #1: COntinua abajo.

  sendEmailEstimate() {
    this.estimateService
      .sendEstimateEmail(
        this.estimateId,
        this.emails,
        107,
        this.emailBody,
        this.emailSubject
      )
      .then((data) => {
        const resp: any = data;

        //console.log("envio");
        //console.log(resp);

        swal({
          title: "Item creado",
          type: "success",
        });

        document.getElementById("sendHide").click();
        // this.rowsClient = resp.data;
        // this.rowStatic =  resp.data;
        // this.rowsTemp = resp.data;
        // //console.log( this.rowsClient);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  calculateSubtotalWork() {
    //console.log("calular de subtotal actualizar");
    let workforceHourValueTemp = this.changeFormatDecimal(
      this.workforceHourValue
    );
    let value = this.workforcequantity * workforceHourValueTemp;
    this.workforceSubtotal = Number(value).toFixed(0);
    //console.log("this.workforceSubtotal ----- " + this.workforceSubtotal);
    this.finalFormaHourValueSubtotal();
    // this.workforceSubtotal =  this.changeFormatDecimal(this.workforceSubtotal);
  }

  calculateSubtotalWorkUpdate() {
    //console.log("calular de subtotal actualizar");
    let workforceHourValueTempUpdate = this.changeFormatDecimal(
      this.workforceHourValueUpdate
    );
    let value = this.workforcequantityUpdate * workforceHourValueTempUpdate;
    this.workforceSubtotalUpdate = Number(value).toFixed(0);
    //console.log(
    //   "this.workforceSubtotalUpdate ----- " + this.workforceSubtotalUpdate
    // );
    this.finalFormaHourValueSubtotalUpdate();
    // this.workforceSubtotal =  this.changeFormatDecimal(this.workforceSubtotal);
  }

  createNewCustomer() {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    let margin = Number(this.newCustomerMargin) / 100;

    //console.log("Ingreso a crear un nuevo cliente");

    this.restService
      .createCustomer(
        this.nameCustomer,
        3,
        this.documentCustomer,
        this.cellphone,
        "Sin Dirección",
        0,
        margin,
        1,
        this.selectedCityId,
        this.selectedDepartmentId
      )
      .then((data) => {
        const resp: any = data;
        //console.log(resp);
        //console.log("id customer" + resp.data.id);
        if (resp.success === false) {
          swal({
            title: "Este tercero ya esta registrado",
            text: "Este tercero no se puede registrar",
            type: "error",
          });
        } else {
          //console.log("---- respuesta de creación de id");
          //console.log(resp.data);
          this.idCustomerCreated = resp.data.id;
          //console.log("Cambio");

          this.createEstimate();
          /*swal({
           title: 'Tercero agregado',
           type: 'success'
          });*/
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  updateNewCustomer() {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    let margin = Number(this.newCustomerMargin) / 100;

    this.restService
      .createCustomer(
        this.nameCustomer,
        3,
        this.documentCustomer,
        this.cellphone,
        "Sin Dirección",
        0,
        margin,
        1,
        this.selectedCityId,
        this.selectedDepartmentId
      )
      .then((data) => {
        const resp: any = data;
        //console.log(resp);
        //console.log("id customer" + resp.data.id);
        if (resp.success === false) {
          swal({
            title: "Este tercero ya esta registrado",
            text: "Este tercero no se puede registrar",
            type: "error",
          });
        } else {
          this.idCustomerCreated = resp.data.id;
          //console.log("Cambio");

          this.updateEstimate();
          /*swal({
           title: 'Tercero agregado',
           type: 'success'
          });*/
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  //  this.selectedBusinessId != 0 &&

  updateEstimateCondition() {
    //console.log("Ingresa ps");
    if (
      this.documentCustomer !== "" &&
      this.nameCustomer !== "" &&
      this.selectedDepartmentId != 0 &&
      this.selectedCityId != 0 &&
      this.days !== "" &&
      this.guaranty !== "" &&
      this.contact !== "" &&
      this.validity !== ""
    ) {
      //console.log("-- " + this.selectedCityId);

      // if(this.validateEmail(this.email)){

      //  if( this.idCustomerCreated){
      this.updateEstimate();
      /*}else{
        this.updateNewCustomer();
      }*/
      /*  }else{
         swal({
           title: 'Se presento un problema',
           text:'Debe ingresar un correo electrónico valido',
           type: 'error'
          });
       }*/
    } else {
      swal({
        title: "Se presento un problema",
        text: "Debe diligenciar los valores obligatorios(*)",
        type: "error",
      });
    }
  }

  updateEstimate() {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    //estimate_consecutive: number, custmer_id: number, customer_document: string, department_id: number, city_id: number, forklift_id: number, contact: string, payment_method: number, guaranty: number, validity: number, telephone: string, observation: string, total: number, status: number

    let consecutiveTemp = Number(this.consecutive);

    let customerIdTemp;

    if (this.selectedBusinessId != 0) {
      if (this.selectedBusinessId) {
        //console.log("this.selectedBusinessId");
        //console.log(this.selectedBusinessId.id);
        customerIdTemp = Number(this.selectedBusinessId.id);
      } else {
        customerIdTemp = Number(this.idCustomerCreated);
      } // en este else no entraría si funciona
    } else {
      customerIdTemp = Number(this.idCustomerCreated);
    }
    //console.log("customerIdTemp");
    //console.log(customerIdTemp);

    let documentCustomerTemp = this.documentCustomer;
    let nameCustomerTemp = this.nameCustomer;
    let idDepartmentTemp = this.selectedDepartmentId;
    let selectedCityTemp = this.selectedCityId;
    let selectedForkliftIdTemp = this.selectedForkliftId.id;
    let selectedBranchOfficeIdTemp = this.selectedBranchOfficeId.id;
    let contactTemp = this.contact;
    let daysTemp = this.days;
    let guarantyTemp = this.guaranty;
    let validityTemp = this.validity;
    let cellphoneTemp = this.cellphone;
    let observationTemp = this.observation;
    let forkliftTextTemp = this.forkliftText;

    //console.log("Ole: " + forkliftTextTemp);
    this.estimateService
      .updateEstimate(
        this.estimateId,
        customerIdTemp,
        documentCustomerTemp,
        idDepartmentTemp,
        selectedCityTemp,
        selectedForkliftIdTemp,
        contactTemp,
        daysTemp,
        guarantyTemp,
        validityTemp,
        cellphoneTemp,
        observationTemp,
        forkliftTextTemp,
        selectedBranchOfficeIdTemp
      )
      .then((data) => {
        const resp: any = data;
        this.estimateId = resp.data.id;
        this.showEstimateId = false;
        this.showCreateItem = true;
        this.showSaveFile = true;

        //console.log("estimate para crear items");
        //console.log(this.estimateId);
        //console.log("crear cotización");
        //console.log(data);

        this.estimateService
          .updateConsecutive()
          .then((data) => {
            const resp: any = data;
            //console.log(data);

            swal({
              title: "encabezado actualizado",
              type: "success",
            });

            // swal.close();
            // this.rowsClient = resp.data;
            // this.rowStatic =  resp.data;
            // this.rowsTemp = resp.data;
            // //console.log( this.rowsClient);
          })
          .catch((error) => {
            swal({
              title:
                "Se presento un problema, para guardar este encabezado cotización",
              type: "error",
            });
            console.log(error);
          });
        // this.rowsClient = resp.data;
        // this.rowStatic =  resp.data;
        // this.rowsTemp = resp.data;
        // //console.log( this.rowsClient);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getBase64Images2() {}

  async getBase64ImageFromUrl(imageUrl) {}

  pp() {}

  formatValue(inputTrm) {}

  // separador para los decimales
  finalFormat(num) {
    num += "";
    var splitStr = num.split(".");
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? "," + splitStr[1] : "";
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, "$1" + "." + "$2");
      //console.log(splitLeft);
    }
    //console.log("Importante oleole");
    //console.log(splitLeft + splitRight);
    return splitLeft + splitRight;
  }
  calculateSubtotal() {
    let priceTemp = this.changeFormatDecimal(this.price);
    // =this.price.toString().replace('.','').replace(',','.');
    let value = priceTemp * this.quantity;
    this.subtotal = this.finalFormat(value);
    //console.log("subtotal--- " + this.subtotal);
  }

  calculateSubtotalUpdate() {
    let priceUpdateTemp = this.changeFormatDecimal(this.priceUpdate);
    let value = priceUpdateTemp * this.quantityUpdate;
    this.subtotalUpdate = this.finalFormat(value);
    //console.log("subtotal-- " + this.subtotalUpdate);
  }

  finalFormatPrice() {
    var num = this.changeFormatDecimal(this.price); //.toString().replace('.','').replace(',','.');
    num += "";
    var splitStr = num.split(".");
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? "," + splitStr[1] : "";
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, "$1" + "." + "$2");
      //console.log(splitLeft);
    }
    //console.log("Importante oleole");
    //console.log(splitLeft + splitRight);
    this.price = splitLeft + splitRight;
  }

  finalFormaHourValue() {
    var num = this.changeFormatDecimal(this.workforceHourValue); // this.changeFormatDecimal(this.workforceHourValue);
    //console.log(num);
    num += "";
    var splitStr = num.split(".");
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? "," + splitStr[1] : "";
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, "$1" + "." + "$2");
      //console.log(splitLeft);
    }
    //console.log("Importante oleole");
    //console.log(splitLeft + splitRight);
    this.workforceHourValue = splitLeft + splitRight;
  }

  finalFormaHourValueUpdate() {
    var num = this.changeFormatDecimal(this.workforceHourValueUpdate); // this.changeFormatDecimal(this.workforceHourValue);
    //console.log(num);
    num += "";
    var splitStr = num.split(".");
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? "," + splitStr[1] : "";
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, "$1" + "." + "$2");
      //console.log(splitLeft);
    }
    //console.log("Importante oleole");
    //console.log(splitLeft + splitRight);
    this.workforceHourValueUpdate = splitLeft + splitRight;
  }

  finalFormaHourValueSubtotal() {
    var num = this.workforceSubtotal; //this.changeFormatDecimal(this.workforceSubtotal); // this.changeFormatDecimal(this.workforceHourValue);
    //console.log(num);
    num += "";
    var splitStr = num.split(".");
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? "," + splitStr[1] : "";
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, "$1" + "." + "$2");
      //console.log(splitLeft);
    }
    //console.log("Importante oleole");
    //console.log(splitLeft + splitRight);
    this.workforceSubtotal = splitLeft + splitRight;
  }

  finalFormaHourValueSubtotalUpdate() {
    var num = this.workforceSubtotalUpdate; //this.changeFormatDecimal(this.workforceSubtotalUpdate); // this.changeFormatDecimal(this.workforceHourValue);
    //console.log(num);
    num += "";
    var splitStr = num.split(".");
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? "," + splitStr[1] : "";
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, "$1" + "." + "$2");
      //console.log(splitLeft);
    }
    //console.log("Importante oleole");
    //console.log(splitLeft + splitRight);
    this.workforceSubtotalUpdate = splitLeft + splitRight;
  }

  finalFormatStandard(priceUpdate: any) {
    var num = priceUpdate; //this.changeFormatDecimal(priceUpdate); // this.changeFormatDecimal(this.workforceHourValue);
    //console.log(num);
    num += "";
    var splitStr = num.split(".");
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? "," + splitStr[1] : "";
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, "$1" + "." + "$2");
      //console.log(splitLeft);
    }
    //console.log("Importante oleole");
    //console.log(splitLeft + splitRight);
    num = splitLeft + splitRight;
    //console.log("Boom");
    //console.log(num);
    return num;
  }

  finalFormatPriceUpdate() {
    var num = this.changeFormatDecimal(this.priceUpdate); //.toString().replace('.','').replace(',','.');
    num += "";
    var splitStr = num.split(".");
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? "," + splitStr[1] : "";
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, "$1" + "." + "$2");
      //console.log(splitLeft);
    }
    //console.log("Importante oleole");
    //console.log(splitLeft + splitRight);
    this.priceUpdate = splitLeft + splitRight;
  }

  clearFormDetail() {
    this.code = "";
    this.description = "";
    this.quantity = 1;
    this.unitCost = 0;
    this.weight = 0;
    this.weightTypeList = 0;
    this.priceList = 0;
    this.suggestedPrice = 0;
    this.price = 0;
    this.subtotal = 0;
    this.deliveryPart = 0;
  }

  clearFormDetailUpdate() {
    this.codeUpdate = "";
    this.descriptionUpdate = "";
    this.quantityUpdate = 1;
    this.unitCostUpdate = 0;
    this.weightUpdate = 0;
    this.weightTypeListUpdate = 0;
    this.priceListUpdate = 0;
    this.suggestedPriceUpdate = 0;
    this.priceUpdate = 0;
    this.subtotalUpdate = 0;
    this.deliveryPartUpdate = 0;
  }

  clearFormDetailWork() {
    this.workforceCode = "";
    this.workforceService = "";
    this.workforcequantity = 1;
    this.workforceHourValue = 0;
    this.workforceSubtotal = 0;
    this.workforceDelivery = 0;
  }

  clearFormDetailWorkUpdate() {
    this.workforceCode = "";
    this.workforceService = "";
    this.workforcequantity = 1;
    this.workforceHourValue = 0;
    this.workforceSubtotal = 0;
    this.workforceDeliveryUpdate = 0;
  }

  cancelFormDetail() {
    document.getElementById("createItemHide").click();
    this.clearFormDetail();
  }

  cancelFormDetailUpdate() {
    document.getElementById("updateItemHide").click();
    this.clearFormDetailUpdate();
  }

  cancelFormWorkCreate() {
    document.getElementById("createHideWorkforce").click();
    this.clearFormDetailWork();
  }

  cancelFormDetailWorkforceUpdate() {
    document.getElementById("updateHideWorkforce").click();
    this.clearFormDetailWorkUpdate();
  }
  //funcion limpiar y validar campos obligatorios

  ///////////Paquete #1 ****** Paquete #1

  //**Comienza ---Espacio para funciones de prueba
  //**Comienza ---Espacio para funciones de prueba
  //**Comienza ---Espacio para funciones de prueba

  toggleCountrySelection(country: Country) {
    this.selectedCountries[country.id] = !this.selectedCountries[country.id];
  }

  get countries(): Country[] {
    return this.filteredCountries
      .map((country, i) => ({ id: i + 1, ...country }))
      .slice(
        (this.page - 1) * this.pageSize,
        (this.page - 1) * this.pageSize + this.pageSize
      );
  }
  //Funciona
  toggleEstimateSelection2(estimatedata: estimatedata) {
    estimatedata.selected = !estimatedata.selected;
    if (estimatedata.selected) {
      // Si el registro está siendo seleccionado meter el array en la ariable temporal
      this.selectedestimates[estimatedata.estimate_id] = estimatedata;
      this.selectedestimatesTemp.push(estimatedata);
    } else {
      // Si el registro está siendo des-seleccionado
      // Buscar y eliminar el registro de selectedestimatesTemp
      delete this.selectedestimates[estimatedata.estimate_id];

      const index = this.selectedestimatesTemp.findIndex(
        (est) => est.estimate_id === estimatedata.estimate_id
      );
      if (index !== -1) {
        this.selectedestimatesTemp.splice(index, 1);
      }
    }

    console.log(
      "Elemento seleccionado desde el array de la tabla:",
      estimatedata
    );
    console.log("Data temporal:", this.selectedestimatesTemp);
  }
  cancelCreateOS() {
    window.location.reload();
  }

  createOrderservice() {
    
    console.log("creando orden de servicio:", this.selectedestimatesTemp);
    //console.log("creando orden de servicio:", this.selectedestimatesTemp.create_at);
    let totalSum = 0;
    this.estimateDataDetails.forEach((item) => {
      let priceTotal = parseFloat(item.total) || 0;
      let hourValue = parseFloat(item.hour_value) || 0;
      item.total = (priceTotal + (hourValue * item.quantity));
    });

    for (let i of this.estimateDataDetails) {
      totalSum += parseFloat(i.total);
      console.log('/*/*/*/', totalSum, ' + ', i.total);
    }
    this.ProgressOS = 0;
    this.TotalAbsolutOS = totalSum;

    console.log(this.estimateDataDetails);
    console.log("TotalAbsolutOS de todos los items:", this.TotalAbsolutOS);
    console.log(
      "Parametro a pasar con Suma total de todos los items:",
      this.TotalAbsolutOS
    );

    console.log("Suma total de todos los items:", totalSum);
    console.log("TotalAbsolutOS de todos los items:", this.TotalAbsolutOS);
    let selectedEstimatesArray = this.selectedestimatesTemp;
    if (selectedEstimatesArray.length === 0) {
      swal({
        title: "Se presento un problema",
        text: "Debe seleccionar almenos una cotizacion(*)",
        type: "error",
      });
      return;
    }

    if(this.descuentoOrderService){
      console.log("Acaaa item de descuento",this.descuentoOrderService)
      console.log("Acaaa total Antes de descuento",this.TotalAbsolutOS)
      this.TotalAbsolutOS=this.TotalAbsolutOS-(this.TotalAbsolutOS*this.descuentoOrderService)
      console.log("Acaaa total con el nuevo descuento",this.TotalAbsolutOS)
    }

    if(this.anticipoOrderService){
      console.warn("Acaaa item de Anticipo",this.anticipoOrderService);
      console.warn("Acaaa item de Nuevo total Antes",this.TotalAbsolutOS);
      const now = new Date();
      const localISOTime = new Date(
        now.getTime() - now.getTimezoneOffset() * 60000
      ).toISOString();
      this.fecha_anticipo=localISOTime;
      
    }
    


    ////Definiendo la validacion por fechas. 
    const validezmaximadeoferta = 30; ///// Esta es la validez maxima definida por el SR Santiago
    const createAtArray = selectedEstimatesArray.map((estimate) => estimate.create_at);
    const validityArray = selectedEstimatesArray.map((estimate) => estimate.validity);
     // Obtener la fecha actual
    const today = new Date();

  
    const dateDifferences = selectedEstimatesArray.map((estimate) => {
      const createdAt = new Date(estimate.create_at); 
      const differenceInTime = today.getTime() - createdAt.getTime(); 
      const differenceInDays = Math.floor(differenceInTime / (1000 * 60 * 60 * 24)); 
      return {
        create_at: estimate.create_at,
        estimate_consecutive:estimate.estimate_consecutive,
        differenceInDays,
      };
    });

    // Mostrar las diferencias en consola
   console.warn("Diferencias de días desde la creación:", dateDifferences);
  
    
    console.warn("Fechas de creación (create_at):", createAtArray);
    console.warn("Validez de las cotizaciones (validity):", validityArray);
    
    const invalidEstimate = dateDifferences.find(
      (date) => date.differenceInDays > validezmaximadeoferta
    );

    if (invalidEstimate) {
      swal({
        title: "Se presento un problema",
        text: `La cotización  ${invalidEstimate.estimate_consecutive} excede la validez máxima de ${validezmaximadeoferta} días. Por favor actualice la oferta con una nueva`,
        type: "error",
      });
      return;
      //window.location.reload()
      
      
    }
    

    //// *******Aca termina  validacion por fechas. 

    ///Acaa construido normalmente. Continua el flujo 
    selectedEstimatesArray = selectedEstimatesArray.map((estimate) => {
      return {
        ...estimate,
        orderservice_consecutive: this.consecutive,
        total_AbsOS: this.TotalAbsolutOS,
        progressBar_value: this.ProgressOS,
        user_make_os: this.user_make_os,
        warehouse_id:11, //// Se pasa en 11 por indicacion del sr santiago
        deliveryAddress:this.deliveryAddressCustomer.address,
        department_name:this.deliveryAddressCustomer.department_name,
        department_id:this.deliveryAddressCustomer.department_id,
        warehouse_description:"REPUESTOS REMISIONADOS",
        descuento_orderService:this.descuentoOrderService,
        anticipo_orderService:this.anticipoOrderService,
        fecha_anticipo:this.fecha_anticipo,
        city_name:this.deliveryAddressCustomer.citi_name,


        
      };
    });
    this.orderservice_email_data = selectedEstimatesArray; /// Aca asigno la data que voy a enviar por email. 

    console.log("Array seleccionado para envio:", selectedEstimatesArray);

        this.orderservice
          .createOrderservice(selectedEstimatesArray)
          .then((data) => {
            if (data && typeof data === "object" && "success" in data) {
              console.log("Se ha creado el POST POST POST POST POST", data);

              //Se reinicia y se vuelve a consultar el consecutivo para asegurarnos de que traiga el nuevo valor de la orden

              this.createOrderserviceDetails();
            } else {
              console.log("Error al crear POSTLOGIST:", data);
              swal.close();
              swal({
                title: "Se presento un problema",
                text: "Esta cotizacion ya esta asociada a una Orden de pedido o el consecutivo esta repetido",
                type: "error",
              });
              window.location.reload();
              //this.router.navigateByUrl("erp/customerorder");
            }
          });
        
  }

  createOrderserviceDetails() {
    console.log("creando orden de servicioDetails:");
    //console.log("Datos:", this.estimateDataDetails);
    console.log("Dato consecutivo OS:", this.consecutive);

    let estimateDataDetailstemp = this.estimateDataDetails;

    ///Mapeo de dato para agregar consecutivo para Post
    estimateDataDetailstemp = estimateDataDetailstemp.map((item) => {
      return {
        ...item,
        orderservice_consecutive: this.consecutive,
        order_observation: this.generalObservations,
        customer_email: this.customeremail,
        dispatchType: this.dispatchType,
      };
    });
    console.log("Array pasado ---->:", estimateDataDetailstemp);
    
    
     this.orderservice
       .createOrderserviceDetails(estimateDataDetailstemp)
       .then((data) => {
         if (data && typeof data === "object" && "success" in data) {
           this.uploadAll();
           this.updateConsecutive();

           console.log("Se ha creado el post", data);
           swal({
             title: "Orden de servicio creada correctamente",
             type: "success",
           });
         } else {
           console.log("Error al crear POSTLOGIST:", data);
           // Manejo Adicional de errores
         }
       }); 
      
  }

  submitSelectedEstimates() {
    let selectedEstimatesArray = this.selectedestimatesTemp;
    if (selectedEstimatesArray.length === 0) {
      swal({
        title: "Se presento un problema",
        text: "Debe seleccionar almenos una cotizacion(*)",
        type: "error",
      });
      return;
    }
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    selectedEstimatesArray = selectedEstimatesArray.map((estimate) => {
      return { ...estimate, orderservice_consecutive: this.consecutive };
    });
    selectedEstimatesArray.forEach((estimate, index) => {
      console.log(
        `Pasando parametro a funcion------> :`,
        estimate.estimate_id
        // Agregar mas propiedades de aca para abajo.
      );

      this.getEstimateDetail(estimate.estimate_id);
    });

    ///Discriminacion con foreach para Consecutivo si se necesita
    selectedEstimatesArray.forEach((estimate, index) => {
      console.log(
        `Discriminación de datos, consecutivo Order service:`,
        estimate.estimate_consecutive
        // Agregar mas propiedades de aca para abajo.
      );
    });

    // console.log(`paso de fecha:`, this.now);
    // console.log(`paso de usuario:`, this.user);
  }

  getEstimateDetail(estimate_id) {
    console.log(
      "paso de parametro de consulta para detalle desde getEstimateDetail:",
      estimate_id
    );

    this.orderservice
      .getOrderServicedatadetails(estimate_id)
      .then((data) => {
        this.showestimatedetails = true;
        const resp: any = data;
        //console.log("oficinas: " + data);

        if (!this.estimateDataDetails) {
          this.estimateDataDetails = [];
        }

        // Concatenar los datos recibidos con los existentes
        this.estimateDataDetails = this.estimateDataDetails.concat(resp.data);
        this.estimateDataDetails = [ ...this.estimateDataDetails ].reverse();
        this.estimateDataDetails.map(detail => {
          detail.baseValue = detail.total / detail.quantity;
        });

        console.log(this.estimateDataDetails);
        swal({
          title: "Por favor confirme los items:",
          type: "success",
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  updateTotal(item: any) {
    let base = parseFloat(item.baseValue) || 0;
    item.total = base * item.quantity;
  }

  //////IMPORTANTEEEE---- SE CREA ITEMS Y SE CREA DETALLE CODIGO COMENTADO DE CADA FUNCION
  ///Se realizan las validaciones de campos y se envia todo para creacion
  submitItems() {
    
    
    let formIsValid = true;

    // Validar que todos los items tengan una cantidad válida
    for (let item of this.estimateDataDetails) {
      if (item.quantity < 0) {
        formIsValid = false;
        swal({
          title: "Cantidad inválida",
          text: "La cantidad debe ser mayor o igual que 0.",
          type: "error",
        });
        return; // Salir de la función si una cantidad no es válida
      }
    }

    // Validar que el correo del cliente no sea vacío
    if (!this.customeremail || this.customeremail.trim() === "") {
      formIsValid = false;
      swal({
        title: "Correo inválido",
        text: "El correo del cliente es obligatorio.",
        type: "error",
      });
      return; // Salir de la función si el correo es vacío
    }

    // Validar que el tipo de despacho no esté vacío
    if (!this.dispatchType || this.dispatchType.trim() === "") {
      formIsValid = false;
      swal({
        title: "Tipo de despacho inválido",
        text: "Debe seleccionar un tipo de despacho",
        type: "error",
      });
      return; // Salir de la función si el tipo de despacho es vacío
    }
    if (!this.deliveryAddressCustomer ) {
      formIsValid = false;
      swal({
        title: "Direccion invalida",
        text: "Debe seleccionar una direccion de entrega",
        type: "error",
      });
      return; 
    }

    

    // Si el formulario es válido, proceder con la creación del servicio y sus detalles
    if (formIsValid) {
      swal({
        title: "Validando información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();
      this.createOrderservice();

      ///Aca funcion para envio de correo
      //this.sendEmailNotifications();
    }
      
  }

  //Funciona
  truncateZeros(value: any | null | undefined): string {
    if (value === null || value === undefined) {
      return "";
    }
    return parseFloat(value)
      .toFixed(4)
      .replace(/\.?0+$/, "");
  }

  async updateConsecutive() {
    console.log("Actualizando el consecutivo desde la creación del detalle...");
    try {
      const data: any = await this.orderservice.updateConsecutive();
      console.log("Consecutivo actualizado", data);
      this.sendEmailNotifications();
    } catch (error) {
      console.error("Error al actualizar el consecutivo", error);
    }
  }

  //Funciona
  getDateOnly(dateTime: string): string {
    return dateTime.split(" ")[0];
  }

  onSelectFile(event) {
    var filesAmount = event.target.files.length;

    var filename = event.target.files[event.target.files.length - 1].name;
    //console.log("Nombre de archivo");
    //console.log(filename);
    //  var allowedExtensions = /(.jpg|.jpeg|.png|.gif)$/i;
    //  //console.log(allowedExtensions.exec(filename));
    var extFilename = filename.split(".").pop();

    //console.log("-----");
    //console.log(extFilename);

    // if(extFilename !=='jpg' && extFilename !=='jpeg' && extFilename !=='png'){
    //console.log("filename que es");
    var filename = event.target.files[event.target.files.length - 1].name;
    //console.log(filename);
    this.urlsFiles.push(filename);
    this.selectedFiles.push(event.target.files);
    /*}else{
    swal({
      title: 'El formato del archivo, no es correcto',
      text: 'No se permite cargar archivos con extensión jpg, jpeg, png ',
      type: 'error'
    });
    }*/
  }

  uploadFiles() {
    for (let fileCurrent of this.selectedFiles) {
      const file = fileCurrent[0];
      //console.log(file);
      //  const uuid = UUID.UUID();
      // //console.log(uuid);
      //console.log(file.name + "." + file.type);

      let nameTemp = this.removeAccents(
        this.consecutive + this.normalizes(file.name.replace(/\s/g, ""))
      );
      const extension = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();
      //console.log(extension);
      this.uploadService
        .uploadOSFilesAll(file, this.consecutive, 0, nameTemp)
        .then((res) => {
          //console.log("s3info" + JSON.stringify(res));
          this.s3info = res;
          //console.log(this.s3info);
          /*swal({
          title: 'Archivos guardados',
          type: 'success'
         });*/

          swal.close();
          this.showSaveFile = false;
        })
        .catch((error) => {
          console.log(error);
          swal({
            type: "error",
            title: "Oops a currido un error",
            text: "Se ha presentado un error al subir la imagen",
            allowOutsideClick: false,
          });
        });
    }
  }
  uploadAll() {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    this.uploadFiles();

    swal({
      title: "Archivos guardados",
      type: "success",
    });
  }
  isValidForm(): boolean {
    // Verificar que todos los items tengan una cantidad válida
    for (let item of this.estimateDataDetails) {
      if (!item.quantity || item.quantity < 0) {
        return false;
      }
    }
    // Verificar que el tipo de despacho y el correo del cliente sean válidos
    if (
      !this.dispatchType ||
      !this.customeremail ||
      !this.customeremail.includes("@")
    ) {
      return false;
    }
    return true;
  }

  //// Comeinza Paquete de envio de correos
  sendEmailNotifications() {
   
   
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    //Indico el email de notificacion (cartera y el correo cliente)
    this.emailcartera = "cartera@montacargasmaster.com.co";
    const updateData: any = {
      emails: [this.customeremail, this.emailcartera],

      orderservice: this.orderservice_email_data,
      orderserviceDetail: this.estimateDataDetails,
    };
    //console.log("Holaaa desde donde mando correo", updateData);
    console.log("Acaaa datos primer correo", updateData);
    this.orderservice
      .sendEmailNotifications(this.consecutive, updateData)
      .then(() => {
        swal.close();
        this.router.navigateByUrl("erp/serviceorder");
      })
      .catch((error) => {
        // Manejar el error en caso de que la promesa sea rechazada
        console.error("Error al enviar notificaciones por correo:", error);
      });
  }

  formatNumber(value: number): string {
    if (value === null || value === undefined) {
      return "";
    }

    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  }

  //// Termina Paquete de envio de correos

  ////Acaaa comienza modificaciones en creacion
 

  openCardFormForMaintenance() {
    this.showFormMaintenance = true;
    console.log("Acaaa ya abri la card para llenarla");
  }

 


  closeCardFormForMaintenance() {
    this.showFormMaintenance = false;
    console.log("Acaaa ya Cerre la card para llenarla");
  }
  openCardFormForCotizacion() {
    this.showFormCotizacion = true;
    console.log("Acaaa ya cambie el estado por cotizacion");
  }

  getDeliverysAdrres(id) {
    console.log("Aca iniciando funcion");
    // console.log("Aca viendo variable",this.selectedBusinessIdForm)

    //   const customer_id = this.selectedBusinessIdForm.id;

    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.orderservice
      .getDeliverysAdrres(id)
      .then((data) => {
        const resp: any = data;
        console.log(data);

        this.deliveryAddress = resp.data;
        console.warn(
          "Data recibida de direcciones de entrega:",
          this.deliveryAddress
        );

        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  clearProductFields(): void {
    this.reference = "";
    this.description = "";
    this.quantityForm = 0;
    this.pidUnit = 0;
    this.unitWeight = 0;
    this.codeForm = "";
    this.selectedOriginId = "";
    this.weightType = "";
  }

  editItemForm(item: any) {
    // Llenar los campos con los datos del producto seleccionado
    this.editIndex = this.productList.indexOf(item);
    //this.selectedBusinessIdForm = item.selectedBusinessIdForm;
    //this.warehouse = item.warehouse;
    this.selectedOriginId = item.price_list;
    this.observationForm = item.order_observation;
    this.description = item.description;
    this.quantityForm = item.quantity;
    this.pidUnit = item.unit_cost;
    this.unitWeight = item.weight;
    this.codeForm = item.code;
    this.weightType = item.weight_type;



    // totalPidUnit: totalPidUnit,
    //   totalWeight: totalWeight,
      


    //   ////Aca Data para pasar
    //   code: this.codeForm,
    //   create_at: new Date().toISOString(),
    //   description: this.description,
    //   ed_id:0,
    //   estimate_consecutive:1,
    //   orderservice_consecutive:this.consecutive,
    //   price_list:this.selectedOriginId,
    //   quantity: this.quantityForm,
    //   unit_cost:this.pidUnit,
    //   weight: this.unitWeight.toString(), /// Texto
    //   weightType: this.weightType,  /// Texto
    //   order_observation: this.observationForm,
    //   idel:0,
    //   customer_email:"",
  }

  deleteItemForm(item: any) {
    // Eliminar el producto del array
    const index = this.productList.indexOf(item);
    if (index !== -1) {
      this.productList.splice(index, 1);
      console.log("Producto eliminado:", item);
      console.log("Lista de productos actualizada:", this.productList);
    }
  }

  
  addProductsForm() {
    console.log("Acaaa agregare nuevos productos");
    if (
      !this.selectedBusinessIdForm ||
      !this.warehouse ||
      !this.selectedOriginId ||
      !this.weightType ||
      !this.description ||
      !this.quantityForm ||
      !this.pidUnit ||
      !this.unitWeight ||
      !this.codeForm
    ) {
      alert(
        "Por favor complete todos los campos antes de agregar el producto."
      );
      return;
    }
    if (this.quantityForm <= 0|| !Number.isInteger(this.quantityForm)) {
      alert("La cantidad debe ser numero entero y positivo.");
      return;
    }
    //const totalPidUnit = this.pidUnit * this.quantityForm;
    const totalPidUnit = Number((this.pidUnit * this.quantityForm).toFixed(3));
    //const totalWeight = this.unitWeight * this.quantityForm;
    const totalWeight = Number((this.unitWeight * this.quantityForm).toFixed(2)); ///Acaa redondeado a 2 decimaless
    const productData = {
      id_product_form: this.productList.length + 1,
      
      // clientID: this.selectedBusinessIdForm.id,
      // DataCustomer: this.selectedBusinessIdForm,
      // warehouse_id: Number(this.warehouse.code),
      // warehouseDescription: this.warehouse.description,
      // warehouseFULL: this.warehouse,
      //selectedOriginId: this.selectedOriginId,
      //pidUnit: this.pidUnit,
      totalPidUnit: totalPidUnit,
      totalWeight: totalWeight,
      


      ////Aca Data para pasar
      code: this.codeForm,
      create_at: new Date().toISOString(),
      description: this.description,
      ed_id:0,
      estimate_consecutive:1,
      orderservice_consecutive:this.consecutive,
      price_list:this.selectedOriginId,
      quantity: this.quantityForm,
      unit_cost:this.pidUnit,
      weight: this.unitWeight.toString(), /// Texto
      weight_type: this.weightType,  /// Texto
      order_observation: this.observationForm,
      idel:0,
      customer_email:"",

      
    };

    if (this.editIndex !== null) {
      // Actualizar el producto existente
      this.productList[this.editIndex] = productData;
      console.log("Producto editado:", productData);
    } else {
      // Agregar un nuevo producto
      this.productList.push(productData);
      console.log("Producto agregado:", productData);
    }
   

    // Mostrar en consola el producto agregado y la lista completa
    console.log("Producto agregado:", productData);
    console.log("Lista de productos actual:", this.productList);

    // Limpiar los campos después de agregar
    this.clearProductFields();
    this.editIndex = null; 
    this.updatePldTotal();

    // Devolver la lista actualizada
   // return this.productList;
  }
  updatePldTotal() {
    this.pldTotalForm = this.productList.reduce(
      (total, product) => total + product.totalPidUnit,
      0
    );
    console.log("pldTotal actualizado:", this.pldTotalForm);
  }

  sendFormOrderService() {
    
    if (this.productList.length <= 0) {
      alert("Para crear la orden debe Ingresar los productos");
      return;
    }

    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    const PosDataForm={
      /// Acaa donde tengo almacenadas las variables
      //warehouse:this.warehouse,
      //customer:this.selectedBusinessIdForm,
      //Acaa datos
      orderservice_consecutive:this.consecutive,
      customer_id:this.selectedBusinessIdForm.id,
      business_name:this.selectedBusinessIdForm.business_name,
      city_id:this.selectedBusinessIdForm.city_id,
      warehouse_id:this.warehouse.id,
      warehouse_description:this.warehouse.description,
      user_make_os:Number(this.user_make_os),
      create_at: new Date().toISOString(),
      customer_document:this.selectedBusinessIdForm.document_id,
      payment_method:this.selectedBusinessIdForm.day,
      elaborate_user_id:Number(this.user_make_os),
      estimate_consecutive:1,
      idel:0,
      status:0,
      progressBar_value:0,
      pldTotal:this.pldTotalForm,
      user_name:this.username,

    }
    
    console.log("Acaaa data post encambezado",PosDataForm);
    console.warn("Acaa data de detalle",this.productList);
    ///aca logica del Post
     this.orderservice
         .createOrderserviceForm(PosDataForm)
         .then((data) => {
           if (data && typeof data === "object" && "success" in data) {
             console.log("Se ha creado el POST POST POST POST POST", data);

             //Se reinicia y se vuelve a consultar el consecutivo para asegurarnos de que traiga el nuevo valor de la orden

             this.createOrderserviceDetailsForm();
             this.sendEmailNotificationsForm(PosDataForm)
           } else {
             console.log("Error al crear POSTLOGIST:", data);
             swal.close();
             swal({
               title: "Se presento un problema",
               text: "Esta Orden posee consecutivo esta repetido contactese con soporte",
               type: "error",
             });
             //window.location.reload();
             //this.router.navigateByUrl("erp/customerorder");
           }
         });
  }
  sendEmailNotificationsForm(PosDataForm){

    const orderserviceData=PosDataForm
    const orderserviceDataDetail=this.productList
    console.warn("Acaaaa Envio correo");
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    //Indico el email de notificacion (cartera y el correo cliente)
     this.emailcartera = "cartera@montacargasmaster.com.co";
    
     const updateData: any = {
       emails: [this.emailcartera],

       orderservice: orderserviceData,
       orderserviceDetail: orderserviceDataDetail,
     };
     //console.log("Holaaa desde donde mando correo", updateData);
     console.log("Acaaa datos primer correo", updateData);
     this.orderservice
       .sendEmailNotificationsForm(this.consecutive, updateData)
       .then(() => {
         swal.close();
         this.router.navigateByUrl("erp/serviceorder");
       })
       .catch((error) => {
         // Manejar el error en caso de que la promesa sea rechazada
         console.error("Error al enviar notificaciones por correo:", error);
       });
  }


  cancelFormForMaintenance() {
    console.warn("Acaaa cancelo y reinicio formularios");
    // this.showFormMaintenance = false;
    window.location.reload();
  }

  getWareHouse(){
    console.log("Aca iniciando funcion Warehouses");
    // console.log("Aca viendo variable",this.selectedBusinessIdForm)

    //   const customer_id = this.selectedBusinessIdForm.id;

    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.orderservice
      .getWareHouse()
      .then((data) => {
        const resp: any = data;
        console.log(data);

        this.warehouses = resp.data;
        console.warn(
          "Data recibida de WAREHOUSES:",
          this.warehouses
        );

        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  createOrderserviceDetailsForm(){

    this.orderservice
       .createOrderserviceDetailsForm(this.productList)
       .then((data) => {
         if (data && typeof data === "object" && "success" in data) {
           
          

           console.log("Se ha creado el post DEL DETALLEEE", data);
           this.updateConsecutiveForm()
           swal({
             title: "Orden de servicio creada correctamente",
             type: "success",
           });

         } else {
           console.log("Error al crear POSTLOGIST:", data);
           // Manejo Adicional de errores
         }
       }); 
  }

  async updateConsecutiveForm(){
    const data: any = await this.orderservice.updateConsecutive().then(() => {
      console.log("Consecutivo actualizado", data);
      swal.close();
      this.router.navigateByUrl("erp/serviceorder");
    });
  }

  toggleModalEstimateOsList(estimateOsList: any = null) {
    if (estimateOsList) {
      this.osList = estimateOsList;
      this.modalEstimateOsList.show();
      return;
    }

    this.osList = [];
    this.modalEstimateOsList.hide();
  }
  ///////
}



// WEBPACK FOOTER //
// ./src/app/master/master-OS-Customer/master-OS-customer.component.ts